import { useEffect, useState } from 'react';
import GetFetch from '../hooks/GetFetch';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { 
	ROUTE_CREATE_OCCUPANCY_AGREEMENTS, 
	ROUTE_EDIT_OCCUPANCY_AGREEMENTS, 
	ROUTE_OCCUPANCY_AGREEMENTS 
} from '../routes/Routes';
import OccupancyAgreementsTable from './OccupancyAgreementsTable';
import ListViewConfig from '../ListViewConfig/ListViewConfig';
import { BaseButton } from '../components/BaseButton/BaseButton';
import { Button } from 'devextreme-react';

const OccupancyAgreements = () => {
	const [dataSource, setDataSource] = useState([]);
	const [loading, setLoading] = useState(false);
	const [forceReload, setForceReload] = useState(false);
	const [allowEditing, setAllowEditing] = useState(false);
	const [allowCreate, setAllowCreate] = useState(false);
	
	const { user } = useAuth();

	const navigate = useNavigate();

	useEffect(() => {
		getOcccupancyAgreements();
		const permissions = user.role.ModulePermissions?.filter(module => { return (module.Page === ROUTE_OCCUPANCY_AGREEMENTS.module) })
		setAllowEditing(permissions?.filter(module => { return (module.Update) }).length > 0)
		setAllowCreate(permissions?.filter(module => { return (module.Create) }).length > 0)
	}, [])

	const handleAdd = () => {
		navigate('Create');
	};

	const getOcccupancyAgreements = async () => {
		setLoading(true);
		try {
			const { Errors, Message, Success } = await GetFetch('/v1/OccupancyAgreement/Table');
			if (Success) {
				setDataSource(
					Message.map(({
						CreatedDate,
						CreatedBy,
						Inactive,
						UpdatedDate,
						UpdatedBy,
						...rest
					}) => ({
						Status: Inactive ? "Inactive" : "Active",
						...rest
					}))
				)
			}

			if (Errors.length > 0) console.error(Errors);
		} catch (error) {
			console.error(error);
		}
		setLoading(false);
	};

	const routeToEditOccupancyAgreementModule = ({ data }) => {
		navigate(
			ROUTE_EDIT_OCCUPANCY_AGREEMENTS.withSlash,
			{ state: data.OccupancyAgreementId }
		)
	};

	const handleKeyDown = (keyValue, e) => {
        if (keyValue.keyCode !== 13) return;

        if (keyValue.keyCode === 13) {
            keyValue.preventDefault();
            routeToEditOccupancyAgreementModule(e);
        };
    };
    
	const childProps = {
		addRecordText: "Create an Occupancy Agreement",
		addRecordHandler: () => navigate(ROUTE_CREATE_OCCUPANCY_AGREEMENTS.withSlash),
		columns: [
			{
				dataField: "OccupancyAgreementId",
				visible: false
			},
			{
				caption: "OA Number",
				cellRender: (e) => {
					return (
						allowEditing ?
						<button
							style={{
								background: 'none',
								color: '#1F476B',
								border: 'none',
								textDecoration: 'underline',
								fontWeight: '700',
								fontSize: 'inherit',
								padding: '0',
								cursor: 'pointer'
							}}
							onClick={() => routeToEditOccupancyAgreementModule(e)}
						>
							Edit: {e.data.OANumber}
						</button>
						:
						<span> { e.data.OANumber } </span>
					)
				},
				dataField: "OANumber"
			},
			{
				caption: "Agency Name",
				dataField: "AgencyName"
			},
			{
				caption: "Building Number",
				dataField: "BuildingNumber"
			},
			{
				caption: "Effective Date",
				dataField: "EffectiveDate"
			},
			{
				caption: "Expiration Date",
				dataField: "ExpirationDate"
			},
			{
				caption: "Lease Number",
				dataField: "LeaseNumber"
			},
			{
				caption: "Member Name",
				dataField: "MemberName"
			},
			{
				caption: "Total Rent Sq. Ft.",
				dataField: "TotalRentSqFt"
			},
			{
				caption: "Status",
				dataField: "Status"
			},
			{
				datafield: "CreatedBy",
				visible: false
			},
			{
				datafield: "CreatedDate",
				visible: false
			},
			{
				datafield: "UpdatedBy",
				visible: false
			},
			{
				datafield: "UpdatedDate",
				visible: false
			},
		],
		dataSource,
		exportEnabled: true,
		loadingIndicatorMessage: "Getting Occupancy Agreements. Please wait...",
		loadingIndicatorState: loading,
		loadingIndicatorLocationId: "list-view",
		permissions: {
			allowEditing,
			allowCreate
		},
		showAddRecordButton: true,
		showSearchPanel: true,
        showToolBar: true,
		title: ROUTE_OCCUPANCY_AGREEMENTS.title
	};

	return <ListViewConfig { ...childProps } />;
}

export default OccupancyAgreements;
